/* 🤖 this file was generated by svg-to-ts */
export const DfIconClockFilled16: {
  name: 'clock-filled-16';
  data: string;
} = {
  name: 'clock-filled-16',
  data: `<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm-.002 4.002a1 1 0 0 0-1 1v3a1.02 1.02 0 0 0 .125.485.886.886 0 0 0 .065.102l.02.026.01.012.073.082 2.002 2.009a1 1 0 1 0 1.415-1.414l-1.71-1.716V5.002a1 1 0 0 0-.883-.993Z"/></svg>`
};
